export default `
query getTopBarCouponCode($id: [String]) {
  topbar(filter: {topbar_id: {in: $id}}) {
    content
    coupon
    link
    topbar_id
  }
}
`;
